import React from 'react';
import DarkLogo from '../../resources/images/logos/FullColourLogoBlackTransparent.png';
import LightLogo from '../../resources/images/logos/FullColourLogo.png';
import { Box, useTheme } from '@mui/material';

const HorizontalLogoWithSlogan = () => {
  const theme = useTheme();

  return (
    <Box>
      <div
        sx={{
          backgroundImage: `url(${theme.palette.mode === 'dark' ? DarkLogo : LightLogo})`,
          height: '120px',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          margin: '10px'
        }}></div>
      {/* <Typography className={classes.tagline}>
        Above & Beyond Investing
      </Typography> */}
    </Box>
  );
};

export default HorizontalLogoWithSlogan;
